<template>
  <div class="s-setting-container no-border">
    <div class="flex-row just-between">
      <div class="sac__font-20 semi-bold">
        Agreements
      </div>
      <button
        v-if="screen === 'partnerDetail'"
        type="button"
        class="sac__button bg-transparent"
        @click="handleNewAgreement()"
      >
        + New Agreement
      </button>
    </div>
    <div class="agreement-table-container">
      <v-data-table
        :headers="headers"
        :items="agreements"
        fixed-header
        hide-default-footer
      >
        <template #[`item.agreementId`]="{ item }">
          <td>
            <router-link
              v-if="effectiveDate(item.agreementOrders) === 'Pending'"
              :to="`/agreement/${item.agreementId}/setup`"
            >
              Agreement {{ item.agreementId }}
            </router-link>
            <router-link
              v-else
              :to="`/agreement/${item.agreementId}`"
            >
              Agreement {{ item.agreementId }}
            </router-link>
          </td>
        </template>
        <template #[`item.orderNumbers`]="{ item }">
          <td>
            {{ orderNumbers(item.agreementOrders) }}
          </td>
        </template>
        <template #[`item.agreementPdf`]="{ item }">
          <td>
            <button
              v-if="item.pdfUrl"
              type="button"
              @click="downloadAgreementPdf(item.agreementId, item.pdfUrl)"
            >
              <span class="icon-Document-Text sac__font-18" />
            </button>
          </td>
        </template>
        <template #[`item.startDate`]="{ item }">
          <td class="sac__font-16 right">
            {{ effectiveDate(item.agreementOrders) }}
          </td>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

import unitPreferencesMixin from '@shared/mixins/unitPreferencesMixin';
import partnerAgreementMixin from '@shared/mixins/partnerAgreementMixin';

export default {
  name: 'AgreementSection',
  mixins: [unitPreferencesMixin, partnerAgreementMixin],
  props: {
    screen: String,
    agreements: Array,
    toggleActionModal: Function,
  },
  data() {
    return {
      headers: [{
        text: 'Agreement',
        align: 'start',
        sortable: true,
        value: 'agreementId',
      }, {
        text: 'Order #',
        align: 'start',
        sortable: true,
        value: 'orderNumbers',
      }, {
        text: 'PDF',
        align: 'start',
        sortable: false,
        value: 'agreementPdf',
      }, {
        text: 'Effective Date',
        align: 'end',
        sortable: true,
        value: 'startDate',
      }],
    };
  },
  methods: {
    orderNumbers(orders) {
      let isPaid = false;
      const orderNumbers = [];
      orders.forEach((o) => {
        const {
          orderStatus,
          agreementOrderId,
        } = o;
        if (orderStatus?.toLowerCase() === 'payment pending' && !isPaid) {
          orderNumbers.push(agreementOrderId);
        } else if (orderStatus?.toLowerCase() !== 'payment pending') {
          isPaid = true;
          orderNumbers.push(agreementOrderId);
        }
      });
      return orderNumbers.join(', ');
    },
    handleNewAgreement() {
      this.$store.dispatch('resetNewAgreement');
      this.toggleActionModal(true, 'new-agreement');
    },
    effectiveDate(orders) {
      let isPaid = false;
      let pending = false;
      let earliestStart = null;
      orders.forEach((o) => {
        const {
          plannedStartDate,
          startDate,
          orderStatus,
        } = o;
        const date = startDate || plannedStartDate;
        if (orderStatus?.toLowerCase() === 'payment pending' && !isPaid) {
          pending = true;
        } else if (!earliestStart) {
          isPaid = true;
          earliestStart = moment(date);
        } else if (moment(date).isBefore(earliestStart)) {
          isPaid = true;
          earliestStart = moment(date);
        }
      });
      if (pending) {
        return 'Pending';
      }
      return this.fullDateFormat(earliestStart);
    },
    async downloadAgreementPdf(agreementId, url) {
      const base64 = await this.$store.dispatch('getAgreementPdf', agreementId);
      const regex = /[^/]+(?=\/*(?:\?|#|$))/;
      const fileName = url.match(regex);
      const downloadLink = document.createElement('a');
      downloadLink.href = base64;
      downloadLink.download = fileName;
      downloadLink.click();
    },
  },
};
</script>

<style lang="scss">
.agreement-table-container {
  .v-data-table__wrapper {
    height: 700px;

    thead {
      tr {
        th {
          background-color: $N100 !important;
          color: $WHITE !important;
          font-size: 15px !important;
          font-weight: 500;
          text-transform: uppercase;

          .mdi-checkbox-blank-outline::before,
          .mdi-checkbox-marked::before,
          .mdi-minus-box::before,
          .mdi-arrow-up::before {
            color: $WHITE;
          }

          &:first-child {
            border-top-left-radius: 6px;
          }

          &:last-child {
            border-top-right-radius: 6px;
          }

          &.sortable {
            i {
              display: none;
            }
          }

          &.active {
            i {
              display: inline-block;
            }
          }
        }
      }
    }

    tbody {
      tr {
        td {
          border-bottom: 0;

          .mdi-checkbox-marked::before {
            color: $NBLUE100;
          }

          .edit-btn {
            background: $N90;
            color: $WHITE;
            width: 70px;
            padding: 3px;
          }
        }

        &:hover {
          background: none;
        }

        &:nth-child(even) {
          background-color: $NBLUE5 !important;
        }
      }
    }
  }
}
</style>
